import React from "react";
import "./TourDetails.css";

export default function TourDetails({
  title,
  duration,
  includes,
  heroImage,
  galleryImages,
  tourPlan,
}) {
  return (
    <div className="tour-details-container">

      {/* TOP INFO */}
      <div className="tour-top-info">
        <div className="info-card">
          <div className="icon"><i className="fa-regular fa-clock"></i></div>
          <div>
            <p className="info-label">Duration</p>
            <span className="info-value">{duration}</span>
          </div>
        </div>

        <div className="info-card">
          <div className="icon"><i className="fa-solid fa-location-dot"></i></div>
          <div>
            <p className="info-label">Including</p>
            <span className="info-value">{includes}</span>
          </div>
        </div>
      </div>

      {/* HERO IMAGE */}
      <div className="tour-hero">
        <img src={heroImage} alt="Tour" />
      </div>

      {/* TABS */}
      <div className="custom-tabs">
        <input type="radio" name="tabs" id="tab1" defaultChecked />
        <label htmlFor="tab1">Overview</label>

        <input type="radio" name="tabs" id="tab2" />
        <label htmlFor="tab2">Gallery</label>

        {/* OVERVIEW TAB */}
        <div className="tab content1">
          <h3 className="section-title">Package Inclusions(Packages Can Be Customized As Per The Customers)</h3>

          <ul className="inclusion-list">
            {tourPlan.inclusions.map((item, index) => (
              <li key={index}>
                <i className="fa-solid fa-check"></i> {item}
              </li>
            ))}
          </ul>

          <h3 className="section-title mt-30">Tour Plan</h3>

          <div className="plan-accordion">
            {tourPlan.days.map((day, index) => (
              <details key={index}>
                <summary>
                  <span>Day {index + 1}:</span> {day.title}
                </summary>
                <ul className="Days-list">
                  {day.points.map((p, i) => (
                    <li key={i}>{p}</li>
                  ))}
                </ul>
              </details>
            ))}
          </div>
        </div>

        {/* GALLERY TAB */}
        <div className="tab content2">
          <div className="gallery-grid">
            {galleryImages.map((img, index) => (
              <div className="gallery-item" key={index}>
                <img src={img} alt="Gallery" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
